module.exports = __webpack_public_path__ + "img/parskh.18b4a27.png";